<template>
  <wapi-panel :title="'Параметры территории'" :spacing="false">
    <template v-slot:content>
      <v-tabs background-color="primary" dark>
        <v-tab>WAPI</v-tab>
        <v-tab>GeoJson</v-tab>
        <v-tab>Точки прогнозов</v-tab>
        <v-tab>Точки реанализа</v-tab>

        <v-tab-item>
          <v-card class="overflow-x-hidden mx-auto" :height="height">
            <v-card-text class="pa-0">
              <json-viewer :value="preset" copyable boxed expanded :expand-depth="5" sort></json-viewer>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="overflow-x-hidden mx-auto" :height="height">
            <v-card-text class="pa-0">
              <json-viewer :value="preset.geoJson" copyable boxed expanded :expand-depth="5" sort></json-viewer>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col cols="8">
                <v-select
                  v-model="domainName"
                  :items="domains"
                  item-text="name"
                  item-value="name"
                  label="Выберите домен"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-btn @click="loadForecastPoints">Отобразить</v-btn>
              </v-col>
            </v-row>

            <points-list v-model="forecastPoints" />
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col>
                <v-btn @click="loadRreanalysisPoints">Отобразить</v-btn>
              </v-col>
            </v-row>
            <points-list v-model="reanalysisPoints" />
          </v-container>
        </v-tab-item>
      </v-tabs>
    </template>
  </wapi-panel>
</template>

<script>
import WapiPanel from "../../../components/WapiPanel.vue";
import PointsList from "./PointsList.vue";
import {
  wapiReanalysisPointsForAreaToPoints,
  wapiPointsToPoints
} from "../../../models/mappers/points.js";

export default {
  components: {
    WapiPanel,
    PointsList
  },
  name: "PresetParameters",
  props: {
    preset: Object,
    value: Array,
    coordinateOrder: Array
  },
  async mounted() {
    this.domains = await this.$store.dispatch("FETCH_DOMAINS");
    this.domainName = this.domains[0].name;
    await this.changeDomain();
  },
  data: function() {
    return {
      forecastPoints: [],
      reanalysisPoints: [],
      domainName: "",
      domains: [],
      height: 400
    };
  },
  methods: {
    changeForecastPoints() {
      this.loadForecastPoints();
    },
    changeReanalysisPoints() {
      this.$emit("input", this.reanalysisPoints);
    },
    async changeDomain() {
      await this.loadForecastPoints();
    },
    async loadForecastPoints() {
      if (!this.preset.area) {
        return;
      }
      const markers = await this.$store.dispatch("FETCH_POINTS", {
        domain: this.domainName,
        wapiPolygon2D: this.preset.area
      });
      this.forecastPoints = wapiPointsToPoints(markers, [0, 1]);

      this.$emit("input", this.forecastPoints);
    },
    async loadRreanalysisPoints() {
      const markers = await this.$store.dispatch("FETCH_REANALYSIS_POINTS", {
        presetId: this.preset.id,
        wapiPolygon2D: this.preset.area
      });
      this.reanalysisPoints = wapiReanalysisPointsForAreaToPoints(markers, [
        0,
        1
      ]);

      this.$emit("input", this.reanalysisPoints);
    }
  },
  watch: {
    async preset(newVal) {
      if (!this.domainName) return;

      if (newVal) {
        await this.loadForecastPoints();
        await this.loadRreanalysisPoints();
      }
    }
  }
};
</script>